import { PublicPage as SharedPublicPage } from '@rockalingua/ui';

import useStudentRedirect from './useStudentRedirect.hook';

export default function PublicPage({ children, backgroundVariant }) {
  useStudentRedirect();

  return (
    <SharedPublicPage backgroundVariant={backgroundVariant}>
      {children}
    </SharedPublicPage>
  );
}
